"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFormResponse = instanceOfFormResponse;
exports.FormResponseFromJSON = FormResponseFromJSON;
exports.FormResponseFromJSONTyped = FormResponseFromJSONTyped;
exports.FormResponseToJSON = FormResponseToJSON;
exports.FormResponseToJSONTyped = FormResponseToJSONTyped;
const Answer_1 = require("./Answer");
/**
 * Check if a given object implements the FormResponse interface.
 */
function instanceOfFormResponse(value) {
    if (!('landedAt' in value) || value['landedAt'] === undefined)
        return false;
    if (!('submittedAt' in value) || value['submittedAt'] === undefined)
        return false;
    if (!('answers' in value) || value['answers'] === undefined)
        return false;
    return true;
}
function FormResponseFromJSON(json) {
    return FormResponseFromJSONTyped(json, false);
}
function FormResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'landedAt': json['landed_at'],
        'submittedAt': json['submitted_at'],
        'answers': (json['answers'].map(Answer_1.AnswerFromJSON)),
    };
}
function FormResponseToJSON(json) {
    return FormResponseToJSONTyped(json, false);
}
function FormResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'landed_at': value['landedAt'],
        'submitted_at': value['submittedAt'],
        'answers': (value['answers'].map(Answer_1.AnswerToJSON)),
    };
}
//# sourceMappingURL=FormResponse.js.map